/**
 * 国际化配置
 */
const intl = {
  defaultNameSpace: "equipmentPortal",
  languageFilePath: "./src/languages",
  youDaoId: "07e8c9f66b46d374",
  youDaoSecret: "vabWrn5duH0qoIQxzzNYkMBm23aIBf5T",
};

export default intl;
